import * as React from "react"
import type { SVGProps } from "react"
const SvgSend = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m19.8 13.64-15.4 6.5a1 1 0 0 1-.95-.09.9.9 0 0 1-.45-.84v-13q0-.54.45-.83a1 1 0 0 1 .95-.1l15.4 6.5q.63.3.63.93 0 .66-.63.93M5 17.71l11.85-5L5 7.71v3.5l6 1.5-6 1.5z" />
  </svg>
)
export default SvgSend
